<a [attr.href]="contactUsUrl" target="_blank" class="vl-link mdk-contact-button">
    <p class="vl-icon-wrapper">
        <span class="mdk-contact-button__label">CONTACTEER ONS</span>
        <span class="vl-icon vl-icon--after vl-vi vl-vi-question-mark-filled mdk-contact-button__icon"
            aria-hidden="true"></span>
    </p>
</a>